import React, { Fragment } from "react";
import {
  applyPolyfills,
  defineCustomElements,
} from "@reecegroup/web-component-library/dist/loader/index.cjs";
import Spinner from "../Spinner/Spinner";

applyPolyfills().then(() => {
  defineCustomElements();
});

class EnquireForm extends React.Component {
  constructor(props) {
    super(props);
    this.dialogRef = React.createRef();
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      flowVars: [{ name: "SourceDefaultCountry", type: "String", value: "Australia" },
      { name: "SourceFormHeader", type: "String", value: "Product Enquiry Form" },
      { name: "SourceRequestType", type: "String", value: "Product Enquiry" },
      { name: "SourceProductId", type: "String", value: "" },
      { name: "SourceProductDescription", type: "String", value: "" },
      { name: "SourceURL", type: "String", value: window.location.href },
      { name: "SourcePrivacyPolicyURL", type: "String", value: "" }],
      formCreated: false,
      isButtonVisible: false
    }
  }

  startFlow() {
    // Start the flow with the updated flowVars
    window.$Lightning.createComponent(
      "lightning:flow",
      {},
      "lightningLocator",
      (cmp) => {
        cmp.startFlow("Case_Create_Online_Enquiry", this.state.flowVars);
      }
    );
  }

  componentDidMount() {
    this.checkDocumentReady();
  }

  checkDocumentReady() {
    if (document.readyState === 'complete') {
      this.setState({ isButtonVisible: true });
    } else {
      window.addEventListener('load', () => {
        this.setState({ isButtonVisible: true });
      });
    }
  }

  handleClick() {
    var link = "";
    if (window.location.origin === "https://www.actrol.co.nz") {
      link = window.location.origin + "/privacy-policy/";
    } else {
      link = window.location.origin + "/privacy";
    }

    if (!this.state.formCreated) {
      const newFlowVars = [...this.state.flowVars];
      newFlowVars[3].value = this.props.templateContext.productCode;
      newFlowVars[4].value = this.props.templateContext.productTitle;
      newFlowVars[6].value = link;
      this.setState({ flowVars: newFlowVars, formCreated: true }, () => {
        this.dialogRef.current.show();
        this.startFlow()
      });
    } else {
      this.dialogRef.current.show();
    }
  }

  render() {
    return (
      <Fragment>
        <rg-dialog id="make-an-enquiry" ref={this.dialogRef}>
          <rg-grid gap="small" align-vertical="middle" slot="header">
            <rg-grid-item max-width="4-5">
              <h5>{this.props.templateContext.productTitle}</h5>
              <rg-text-meta>
                Product code: {this.props.templateContext.productCode}
              </rg-text-meta>
            </rg-grid-item>
          </rg-grid>
          <rg-form-enquire>
            <h2>Make an enquiry</h2>
            <rg-grid>
              <rg-grid-item max-width="1-1 5-6@xxs 3-4@xs 3-5@s">
                <p>
                  Submit your enquiry and a member of your local Reece Bathrooms
                  team will be in touch within 2 business days.
                </p>
              </rg-grid-item>
            </rg-grid>
            <style>
              {`
                rg-form{
                  visibility: hidden !important; max-height: 0;
                }
                #lightningLocator .slds-card__body {
                  padding: 10px;
                  border-radius: 12px;
                  font-family: Helvetica !important;
              }
          
          
              .slds-scope {
                  margin-bottom: 40px !important;
              }
          
              .slds-scope .slds-input {
                  background-color: #EBEAEB !important;
                  border: none !important;
                  border-radius: 0px !important;
                  height: 40px !important;
                  color: black;
              }
          
              .slds-scope .slds-select {
                  background-color: #EBEAEB !important;
                  border: none !important;
                  border-radius: 0px !important;
                  height: 40px !important;
                  color: black !important;
              }
          
              .slds-scope .slds-input_faux {
                  background-color: #EBEAEB !important;
                  border: none !important;
                  border-radius: 0px !important;
                  height: 40px !important;
              }
          
              .slds-scope .slds-textarea {
                  background-color: #EBEAEB !important;
                  border: none !important;
                  border-radius: 0px !important;
                  font-style: normal;
                  color: black !important
              }
          
              .slds-scope .slds-checkbox .slds-checkbox_faux {
                  background-color: #EBEAEB !important;
              }
          
              .slds-scope .slds-truncate {
                  padding: 5px 10px !important;
                  font-style: normal;
                  color: black;
              }

              slds-tile__title slds-truncate {
                margin: 0px !important; 
              }
          
              .slds-scope .slds-select_container .slds-select {
                  padding: 10px !important;
                  font-style: normal;
                  color: black
              }
          
              .slds-scope .slds-file-selector__dropzone {
                  border: none !important;
              }
          
              .slds-scope .slds-dropdown-trigger .slds-dropdown {
                  font-size: 12px !important;
              }
          
              .slds-scope .slds-input {
                  font-style: normal;
                  color: black !important
              }
          
              .slds-scope .slds-button_brand {
                font-size: 12px;
                padding: 7px 14px !important;
                background-color: #003057;
              }

              .slds-scope .slds-file-selector__button {
                color: #000000 !important;
                padding: 5px 10px !important;
              }
            
              .slds-file-selector__text{
                color: rgb(153,153,153)
              }
          
              .contactus .grey-bg a{
                  font-size: 14px;
              }

              .slds-scope .slds-select_container:after {
                bottom : calc((var(--lwc-lineHeightButtonSmall, 3rem) / 2) + 5px) !important;
              }
    
              .slds-scope .slds-select_container:before {
                display: none !important;
              }
          
          
              #lightningLocator .slds-form-element__label {
                  font-size: 14px;
                  font-family: Helvetica;
                  color: black;
                  font-style: normal;
                  font-weight: normal;
              }
          
              #lightningLocator .slds-form-element__control {
                  font-size: 14px;
                  font-family: Helvetica;
                  color: #999;
                  font-style: italic;
              }
          
              #lightningLocator .slds-form-element__help {
                  font-size: 12px;
              }
          
              #lightningLocator .slds-rich-text-editor__output {
                  font-size: 14px;
              }
          
              .slds-scope .slds-button_brand:focus {
                  box-shadow: none !important;
              }
              
              .footerContainer {
                  font-size: 14px;
                  width: 18%;
              }
          
              .cFieldSection,
              .slds-rich-text-editor__output {
                  font-size: 14px;
              }
          
              #lightningLocator .slds-rich-text-editor__output {
                  font-size: 14px;
                  color: black;
              }
          
          
              @media (min-width : 1200px) {
                  .container {
                      width: 100% !important;
                  }
              }
          
              @media (min-width : 800px) {
                  .container {
                      width: 100% !important;
                  }
              }
              `}
            </style>
          </rg-form-enquire>
          <div id="lightningLocator"></div>
        </rg-dialog>
        {this.state.isButtonVisible && <Button onclick={this.handleClick}></Button>}
        {!this.state.isButtonVisible && <Spinner size="30px" />}
      </Fragment>
    );
  }
}

const Button = ({ onclick }) => (
  <a
    className="pdp-main-block__btn pdp-main-block__btn--enquire-only"
    onClick={onclick}
  >
    Enquire Now
  </a>
);

export default EnquireForm;
